// extracted by mini-css-extract-plugin
export default {"CompanyInfo":"CompanyInfo_CompanyInfo__GVziW","HighlightedText":"CompanyInfo_HighlightedText__HM4UF"};